export default [
  {
    // path: '/actionCamera/:pageType',
    path: '/actionCamera',
    component: () => import('@/views/actionCamera/Index.vue'),
    name: 'actionCamera',
    meta: {
      title: '运动相机',
      backgroundClass: 'bg-gray',
    },
    hidden: true,
  },
  {
    path: '/actionCamera-pay',
    component: () => import('@/views/actionCamera/PayChose.vue'),
    name: 'actionCamera-pay',
    meta: {
      title: '立即购买',
      backgroundClass: 'bg-gray',
    },
  },
];
